module.exports = __webpack_public_path__ + "static/img/winnipeg2.714a141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/winnipeg2.jpg
// module id = 151
// module chunks = 9